<template>
  <van-popup v-model="showNotice" position="bottom" class="backRect" @closed="onClosed">
    <div v-if="data && data.baseInfo" class="titleRect">
      <van-row gutter="20">
        <van-col span="20" class="title">{{ data.baseInfo.productName }}&nbsp;{{ data.baseInfo.planName }}</van-col>
        <van-col span="4" class="rigth"> <i class="iconfont iconclosex" @click="onClosed" /> </van-col>
      </van-row>
    </div>
    <div class="SelectRect">
      <div v-for="(item,index) in config" :key="index" class="inputRect">
        <van-row gutter="20">
          <van-col span="6" class="title">{{ item.name }}</van-col>
          <van-col span="18">
            <template v-for="(tag,tagIndex) in item.values">
              <van-tag v-if="item.select===tag.value+tag.unit || item.select===tag.value" :key="tagIndex" plain size="large" class="tags" :color="GetColorMainBack()">{{ tag.value }}{{ tag.unit }}</van-tag>
              <van-tag v-else :key="tagIndex" plain size="large" class="tags" @click="onSelectChange(item,tag)">{{ tag.value }}{{ tag.unit }}</van-tag>
            </template>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="downButtonRect">
      <van-row>
        <van-col span="16">
          <div v-if="!loadingPrice" :style="'color:'+GetColorMainBack()" class="priceRect">
            <div>
              <span>￥</span>{{ ShowMoneySpan(price*0.01,true) }}.<span>{{ ShowMoneySpan(price*0.01,false) }}</span>
            </div>
          </div>
          <div v-if="loadingPrice" :style="'color:'+GetColorMainBack()" class="priceRect">
            <van-loading size="1em" text-size="0.5em">试算中...</van-loading>
          </div>

        </van-col>
        <van-col span="8"><van-button :color="GetColorMainBack()" size="large" style="width:100%;height:3em;line-height:3em" @click="onBuyNow">立即投保</van-button></van-col>
      </van-row>

    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Field, Toast, Tag, Loading } from 'vant'
import { getUserBase } from '@/utils/base'
import { ShowMoneySpan, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    [Loading.name]: Loading
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      showNotice: false,
      data: {},
      config: [],
      price: 0,
      loadingPrice: false
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showNotice = true
        this.data = newValue
        this.config = this.data.baseInfo.restrictGenes
        this.price = this.data.baseInfo.price
        this.init()
      } else {
        this.showNotice = false
        this.data = {}
        this.price = 0
        this.config = []
      }
    }
  },
  created() {

  },
  methods: {
    ShowMoneySpan,
    MyNotify,
    getUserBase,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      this.config.forEach(item => {
        item.select = item.defaultValue
        var newValueList = []
        item.values.forEach(value => {
          if (value.step === 0) {
            newValueList.push(value)
          } else {
            for (var i = value.min; i <= value.max; i += value.step) {
              newValueList.push({
                max: i,
                min: i,
                step: value.step,
                type: value.type,
                unit: value.unit,
                value: i
              })
            }
          }
        })
        item.values = newValueList
      })
    },
    onClosed() {
      this.$emit('input', undefined)
    },
    onBuyNow() {
      this.$emit('onbuy', this.config, this.price)
      this.$emit('input', undefined)
    },
    onSelectChange(item, tag) {
      if (tag.unit) {
        item.select = tag.value + tag.unit
      } else {
        item.select = tag.value
      }
      this.config = JSON.parse(JSON.stringify(this.config))
      this.GetSimpleTrial()
    },
    GetSimpleTrial() {
      this.loadingPrice = true
      var data = {
        insuranceProductId: this.data.insuranceProduct.insuranceProductId,
        day: 0,
        yearOld: 20,
        extMap: {
        }
      }
      // 计算扩展参数
      this.config.forEach(item => {
        if (item.name === '旅行延误是否升级') {
          data.extMap['旅行延误是否升级'] = item.select
        } else if (item.key) {
          data.extMap[item.key] = item.select
        } else {
          data.extMap[item.protectItemId] = item.select
        }

        var selectValue = item.values.filter(el => (el.value + el.unit) === item.select)
        if (selectValue.length > 0) {
          selectValue = selectValue[0]
          // 计算保险周期
          if (item.key === 'insurantDateLimit') {
            var i = 0
            if (selectValue.max === selectValue.min) {
              i = selectValue.min
            } else {
              i = parseInt((selectValue.max + selectValue.min) * 0.5)
            }
            if (selectValue.unit === '年') {
              i *= 365
            }
            data.day = i
          }
          // 计算生日
          if (item.key === 'insurantDate') {
            if (selectValue.max === selectValue.min) {
              data.yearOld = selectValue.min
            } else {
              data.yearOld = parseInt((selectValue.max + selectValue.min) * 0.5)
            }
          }
        }
      })

      request({
        url: '/Insurance/GetSimpleTrial',
        method: 'post',
        data: data
      }).then(response => {
        this.loadingPrice = false
        if (!response.success) {
          return
        }
        this.price = response.data.singlePrice
      })
    }
  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    background-color: #fff;
    overflow: hidden;
}
.titleRect{
  padding: 1em;
  font-size: 1.1em;
}
.titleRect .title{
  font-weight: 700;
}
.SelectRect{
  min-height: 30vh;
  max-height: 70vh;
  overflow-y: scroll;
  width: 100vw;
}
.SelectRect .inputRect{
  padding: 0.5em 1em;
  border-top: 1px solid #f5f5f5;
}
.SelectRect .inputRect .title{
  font-size: 0.8em;
  line-height: 2em;
}
.SelectRect .inputRect .tags{
  margin-right: 0.5em;
  margin-bottom:0.5em;
  min-width: 4em;
  text-align: center;
}

.downButtonRect {
  height: 3em;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
}
.downButtonRect .priceRect{
  line-height: 3em;
  padding-left: 1em;
  height: 3em;
  overflow: hidden;
  width: 60vw;
}
.downButtonRect .priceRect div{
  font-size: 1.7em;
}
.downButtonRect .priceRect div span{
  font-size: 0.7em;
}
</style>
